import { useState } from 'react';

const services = [
  'Koltuk Yıkama',
  'Araç Temizliği',
  'Petek Temizliği',
  'Yatak Yıkama',
  'Sandalye Yıkama',
  'İnşaat Sonrası Temizlik',
  'Dış Cephe Cam Temizliği',
  'Otel Yatak Yıkama',
  'Halı / Halıfleks Yıkama',
  'Diğer',
];

const districts = [
  'İstanbul Anadolu Yakası',
  'Yalova',
  'Karamürsel',
  'Kocaeli',
  'İzmit',
  'Diğer Bölge',
];

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) return;

    setStatus('sending');
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      const res = await fetch('https://readdy.ai/api/form/d7d3o1fsch5bvrijfb5g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="iletisim" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-100 text-sky-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            İletişim &amp; Randevu
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">Hemen Randevu Alın</h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Formu doldurun, sizi arayalım. Ücretsiz keşif ve fiyat teklifi için bize ulaşın.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Form Column */}
          <div className="lg:col-span-3">
            <div className="bg-slate-50 rounded-2xl p-6 md:p-8 border border-slate-100">
              <h3 className="text-xl font-bold text-slate-900 mb-1">Randevu Talebi</h3>
              <p className="text-slate-500 text-sm mb-6">Size en kısa sürede dönüş yapacağız.</p>

              {status === 'success' ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                    <i className="ri-check-line text-emerald-600 text-3xl" />
                  </div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Talebiniz Alındı!</h4>
                  <p className="text-slate-500 text-sm">En kısa sürede sizi arayacağız.</p>
                  <button
                    onClick={() => setStatus('idle')}
                    className="mt-6 text-sky-600 font-semibold text-sm hover:underline cursor-pointer"
                  >
                    Yeni Talep Oluştur
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col gap-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Ad Soyad *</label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Adınız ve Soyadınız"
                        className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Telefon *</label>
                      <input
                        type="tel"
                        name="phone"
                        required
                        placeholder="05XX XXX XX XX"
                        className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Hizmet Türü *</label>
                      <select
                        name="service"
                        required
                        className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white cursor-pointer"
                      >
                        <option value="">Hizmet Seçin</option>
                        {services.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Bölge *</label>
                      <select
                        name="location"
                        required
                        className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white cursor-pointer"
                      >
                        <option value="">Bölge Seçin</option>
                        {districts.map((d) => <option key={d} value={d}>{d}</option>)}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">
                      Mesajınız
                      <span className={`ml-2 text-xs ${charCount > 500 ? 'text-red-500' : 'text-slate-400'}`}>
                        ({charCount}/500)
                      </span>
                    </label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      placeholder="Hizmet detayları veya sorularınızı yazabilirsiniz..."
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent resize-none bg-white"
                    />
                  </div>

                  {status === 'error' && (
                    <p className="text-red-500 text-sm text-center">Bir hata oluştu, lütfen tekrar deneyin.</p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'sending' || charCount > 500}
                    className="w-full bg-sky-600 hover:bg-sky-700 disabled:bg-sky-300 text-white font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2 text-base whitespace-nowrap cursor-pointer"
                  >
                    {status === 'sending' ? (
                      <>
                        <i className="ri-loader-4-line animate-spin" />
                        Gönderiliyor...
                      </>
                    ) : (
                      <>
                        <i className="ri-calendar-check-line" />
                        Randevu Talebi Gönder
                      </>
                    )}
                  </button>

                  <p className="text-center text-xs text-slate-400 flex items-center justify-center gap-1">
                    <i className="ri-lock-line" />
                    Bilgileriniz gizli tutulur, üçüncü şahıslarla paylaşılmaz.
                  </p>
                </form>
              )}
            </div>
          </div>

          {/* Contact Info Column */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {/* Phone */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-sky-100 rounded-xl">
                  <i className="ri-phone-line text-sky-600 text-xl" />
                </div>
                <h4 className="font-bold text-slate-900">Hemen Arayın</h4>
              </div>
              <div className="flex flex-col gap-3">
                <a href="tel:05055600419" className="flex items-center gap-2 text-slate-700 hover:text-sky-600 font-semibold transition-colors text-sm whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-fill text-sky-500" />
                  0505 560 04 19
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-xl">
                  <i className="ri-whatsapp-line text-emerald-600 text-xl" />
                </div>
                <h4 className="font-bold text-slate-900">WhatsApp&apos;tan Ulaşın</h4>
              </div>
              <p className="text-slate-500 text-sm mb-4">Hizmet hakkında bilgi almak veya fiyat sormak için mesaj gönderin.</p>
              <a
                href="https://wa.me/905055600419?text=Merhaba%2C%20temizlik%20hizmeti%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-5 py-3 rounded-xl transition-all w-full whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp Mesajı Gönder
              </a>
            </div>

            {/* Service Area */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-sky-100 rounded-xl">
                  <i className="ri-map-pin-2-line text-sky-600 text-xl" />
                </div>
                <h4 className="font-bold text-slate-900">Hizmet Bölgelerimiz</h4>
              </div>
              <div className="flex flex-col gap-2">
                {[
                  'İstanbul Anadolu Yakası',
                  'Yalova',
                  'Karamürsel',
                  'Kocaeli',
                  'İzmit',
                ].map((area) => (
                  <div key={area} className="flex items-center gap-2 text-slate-600 text-sm">
                    <i className="ri-check-line text-sky-500" />
                    {area}
                  </div>
                ))}
              </div>
            </div>

            {/* Hours */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                  <i className="ri-time-line text-amber-600 text-xl" />
                </div>
                <h4 className="font-bold text-slate-900">Çalışma Saatleri</h4>
              </div>
              <p className="text-slate-600 text-sm">Pazartesi – Cumartesi: <strong>08:00 – 20:00</strong></p>
              <p className="text-slate-600 text-sm">Pazar: <strong>09:00 – 17:00</strong></p>
              <p className="text-emerald-600 text-xs font-semibold mt-2 flex items-center gap-1">
                <i className="ri-phone-line" />
                7/24 WhatsApp Destek
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
